import { observable, action, computed, makeObservable } from 'mobx';

import { ServiceGroupServiceList } from './ServiceGroupServiceList';

export class ServiceGroupPage {
    public static Name = 'serviceGroupPage' as const;

    @observable
    public id!: string;

    @observable
    public name: string = '';

    @observable
    public createNewMode: boolean = false;

    @observable
    public services: ServiceGroupServiceList = new ServiceGroupServiceList();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get isValid(): boolean {
        return this.name.length > 0;
    }

    @action
    public reset() {
        this.id = '';
        this.name = '';
        this.createNewMode = false;
        this.services.reset();
    }
}

export const serviceGroupPage = new ServiceGroupPage();
